import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { detectLanguage } from './services/languageDetection';
import { I18N_FALLBACK_LANGUAGE, I18N_SUPPORTED_LANGUAGES } from './i18nConfig';

// Injected by Vite's `define` at build time (see vite.config.ts); guarded for test runners.
declare const __BUILD_ID__: string;

// Initialize i18next with lazy-loaded JSON files and custom language detection
export const i18nReady = (async () => {
  // Detect language using our custom priority logic
  const detectedLanguage = await detectLanguage();
  
  await i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
      lng: detectedLanguage,
      fallbackLng: I18N_FALLBACK_LANGUAGE,
      load: 'currentOnly',
      ns: ['common'],
      defaultNS: 'common',
      supportedLngs: [...I18N_SUPPORTED_LANGUAGES],
      backend: {
        // Version the locale URL with the BUILD id (stable across page loads of one deployment) so
        // the ~95 KB JSON is cacheable by the browser and the CDN edge, while a new deployment still
        // invalidates it. The previous Date.now() buster + cache:'no-store' made every visit re-fetch
        // the full file before FIRST RENDER, directly inflating LCP.
        loadPath: `/locales/{{lng}}/{{ns}}.json?v=${typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'dev'}`
      },
      interpolation: {
        escapeValue: false
      },
      react: {
        useSuspense: false
      }
    });
  
  return i18n;
})();

export default i18n;
